<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap"
                 :size="GCONFIG.styleElFormSize">
<!--            <el-form-item label="">-->
<!--                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>-->
<!--            </el-form-item>-->
            <el-form-item label="发送时间">
                <el-date-picker
                        v-model="queryDate"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="类型">
                <el-select v-model="formInline.messageType" clearable filterable placeholder="类型" @change="onMessageType">
                    <el-option v-for="item in typeList"
                               :key="item.key"
                               :label="item.value"
                               :value="item.key">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="消息模板" v-show="showTemplate">
                <el-select v-model="formInline.messageId" filterable clearable  placeholder="消息模板">
                    <el-option v-for="item in wechatTemplateList"
                               :key="item.messageId"
                               :label="item.messageName"
                               :value="item.messageId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客服消息关键字" v-show="showKeyworld">
                <el-select v-model="formInline.messageId" filterable clearable  placeholder="客服消息关键字">
                    <el-option v-for="item in keyworldList"
                               :key="item.id"
                               :label="item.keyword"
                               :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="平台" v-show="false">
                <el-select v-model="formInline.platformId" clearable filterable placeholder="平台">
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="getList()">查询</el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column prop="CREATE_DATE" label="日期" width="100"></el-table-column>

            <el-table-column prop="SOURCE" label="来源" width="100"></el-table-column>
            <el-table-column prop="ACTION_NAME" label="消息名称" width="200"></el-table-column>
            <el-table-column prop="successCount" label="成功数" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="showDetail(scope.row,1)">{{scope.row.successCount}}</el-button>
<!--                <el-link type="success" :underline="false" href="/#/messagelog?start={{scope.row.CREATE_DATE}}">-->
<!--                  {{scope.row.successCount}}</el-link>-->
              </template>
            </el-table-column>
            <el-table-column prop="failCount" label="失败数" width="100">
              <template slot-scope="scope" >
                <el-button type="text" @click="showDetail(scope.row,0)">{{scope.row.failCount}}</el-button>
<!--                <el-link type="warning" :underline="false" href="/#/messagelog" >{{scope.row.failCount}}</el-link>-->
              </template>
            </el-table-column>


        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getTemplateMessageLogTotalList, getPlatformList, getKeywordsOption,listTemplateMessage} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                listData: [],
                platformData: [],
                loading: false,
                showTemplate:false,
                showKeyworld:false,
              wechatTemplateList:[],
              queryDate:null,
                typeList: [
                    {key: 1, value: '客服消息'},
                    {key: 2, value: '模板消息'}
                ],
                keyworldList:[],
                templateList:[],
                form: {
                    source: '',
                    start: '',
                    end: '',
                    currentPage: 1,
                    pageSize: 15,
                },
                formInline: {
                    source: '',
                    start: '',
                    end: '',
                    messageId:'',
                    messageType:'',
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                },
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一天内',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近两天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近七天',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                platformDisabled: false
            }
        },
        //挂载时候执行
        mounted(){
            //初始化首页数据
            this.getEnableKeyworldList();
            this.getTemplateList();
            this.getPlatformListData();
            this.getList();
        },
        methods: {
            //定义查询方法
            getPlatformListData(){
                getPlatformList(this.formInline).then((res) => {
                    this.platformData = res.data;
                })
            },
            onMessageType(type){
                if(type==1){
                    this.showTemplate=false;
                    this.showKeyworld=true;
                }else if(type=2){
                    this.showTemplate=true;
                    this.showKeyworld=false;
                }
            },
            getEnableKeyworldList(){
                //关键字
                getKeywordsOption({platformId:1}).then((res) => {
                    this.keyworldList = res.data.filter(item => item.type=='text');
                    this.keyworldList.push({'id':0,'keyword':'无'});
                });
            },
            getTemplateList(){
                 this.loading = true;
                 listTemplateMessage({
                     currentPage: 1,
                     pageSize: 250
                 }).then((res) => {
                     this.wechatTemplateList = res.data.messageList.list;
                 })
            },
            getList(){
                this.loading = true;
                if(this.queryDate!=''&&this.queryDate!=null){
                    this.formInline.start=this.queryDate[0];
                    this.formInline.end=this.queryDate[1];
                }
                getTemplateMessageLogTotalList(this.formInline).then((res) => {
                    this.loading = false;
                    if (res.data.status == 200) {
                        //this.formInline.recordsTotal = res.data.value.total;
                        this.listData = res.data.value;
                    }
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            returnHistory(){
                window.history.back()
            },
          showDetail(row,isSuccess){
            this.$router.push({path:'/messageLog',name: 'messageLog',
              params:{},query:{start:row.CREATE_DATE,end:row.CREATE_DATE,messageId:row.MESSAGE_ID,isSuccess:isSuccess}})
          }
        }
    }

</script>
<style>
    .p {
        color: red
    }
</style>



// WEBPACK FOOTER //
// src/views/wechat/messageTotalLog.vue